<template>
    <div class="tendancesSet">
        <TopLogo></TopLogo>
        <!--搜索框-->
        <div class="filter-container">
            <el-button @click="showDialog(null)">add config</el-button>
            <el-input class="searchInput" placeholder="config name" v-model="query.name"></el-input>
            <el-button @click="initData">search</el-button>
        </div>
        <el-table
            v-loading="loading"
            :data="list"
            border>
            <el-table-column label="ID" prop="id_config_system" align="center"/>
            <el-table-column label="name" prop="name" align="center"/>
            <el-table-column label="value" prop="value" align="center"/>
            <el-table-column label="mark" prop="mark" align="center"/>
            <el-table-column label="edit" align="center" width="160">
                <template slot-scope="{ row }">
                    <el-button type="primary" size="mini" @click="showDialog(row)">edit</el-button>
                    <el-button type="primary" size="mini" @click="delConfig(row)">delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="edit" :visible.sync="is_show_dialog" class="dialogBox">
            <el-form v-model="temp" label-position="left" class="formBox" label-width="180px">
                <el-form-item
                    :prop="key"
                    :label="key"
                    v-for="(key,index) of Object.keys(temp)"
                    :key="index">
                    <!-- <div>{{value}}</div> -->
                    <el-input
                        :disabled="['id_config_system',temp.id_config_system?'name':''].includes(key)"
                        :type="'text'"
                        v-model="temp[key]"
                    ></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="submit">submit</el-button>
        </el-dialog>
    </div>
</template>

<script>
import base from '@/api/base';
import TopLogo from "@/components/topLogo";
import {Message} from "element-ui"; // 导入接口域名列表
let commonUtils = require('../../utils/common_utils');

export default {
    name: "configSystemSet",
    components: {TopLogo},
    data() {
        return {
            is_show_dialog: false,
            loading: false,
            base: base,
            query: {},
            rowTemp: {},//选择编辑的tendances
            temp: {
                id_config_system: '',
                name: '',
                value: '',
                mark: '',
            },//编辑后的数据
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.loading = true;
            this.$api.admin.get_config_system(this.query).then(async res => {
                this.loading = false;
                if (res.code == 0) {
                    this.list = res.data;

                    //循环设置图片像素大小
                    // this.setImgWH();
                }
            })
        },
        showDialog(item) {
            this.is_show_dialog = true;
            this.temp = {
                id_config_system: '',
                name: '',
                value: '',
                mark: '',
            };
            if (item) {
                this.rowTemp = {...item};
                this.temp = {...item};
            }
        },
        async submit() {
            if (this.temp.id_config_system) {
                this.submitUpdate();
            } else this.submitAdd();
        },
        async submitUpdate() {
            let changeData = commonUtils.diffData(this.rowTemp, this.temp);
            console.log(this.rowTemp, this.temp,);
            console.log(changeData)
            if (commonUtils.isEmpty(changeData)) return;
            let res = await this.$api.admin.update_config_system({
                ...changeData,
                id_config_system: this.rowTemp.id_config_system
            });
            if (res.code != 0) return;
            Message.success('update success');
            this.initData();
        },
        async submitAdd() {
            if (!this.temp.name || !this.temp.value) return Message.error('params is error');
            let res = await this.$api.admin.add_config_system(this.temp);
            if (res.code != 0) return;
            Message.success('update success');
            this.initData();
        },
        async delConfig(item) {
            if (!item.id_config_system) return Message.error('params is error');
            let res = await this.$api.admin.del_config_system(item);
            if (res.code != 0) return;
            this.initData();
            Message.success('update success');
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/admin/ConfigSystemSet.less">
</style>
